<template>
  <div>
    <!-- 合作流程 -->
    <div class="m-pro-g1">
      <div class="wp">
        <div class="g-tit-g1">
          <h3>合作流程</h3>
          <p>Cooperation process</p>
        </div>
        <ul class="ul-txt-g2">
          <li><span>沟通</span></li>
          <li><span>调研</span></li>
          <li><span>互动</span></li>
          <li><span>策略</span></li>
          <li><span>设计</span></li>
          <li><span>传播</span></li>
          <li><span>管理</span></li>
        </ul>
      </div>
    </div>

    <!-- 咨询部分 -->
    <div class="pic-consult c2">
      <div class="wp">
        <div class="txt">
          <h3>互联网模式下，品牌实现企业资产弯道超车</h3>
          <p class="p1">深挖用户心智 研判用户需求与痛点</p>
          <a href="https://p.qiao.baidu.com/cps/chat?siteId=5212356&userId=5411588" class="btn" target="_blank">免费品牌咨询</a>
        </div>
      </div>
    </div>

    <!-- 标签页部分 -->
    <div class="m-center-g1">
      <div class="wp">
        <ul class="ul-tab-g2 TAB_CLICK">
          <li :class="{ on: activeTab === 'brand' }" @click="activeTab = 'brand'">
            <a href="javascript:;">品牌设计</a>
          </li>
          <li :class="{ on: activeTab === 'design' }" @click="activeTab = 'design'">
            <a href="javascript:;">设计前沿</a>
          </li>
          <li :class="{ on: activeTab === 'news' }" @click="activeTab = 'news'">
            <a href="javascript:;">豪禾动态</a>
          </li>
        </ul>

        <!-- 品牌设计标签页 -->
        <div class="tab-con2" :class="{ ok: activeTab === 'brand' }">
          <div class="row-news fix">
            <div class="col-l">
              <ul class="list-news">
                <li v-for="(item, index) in brandNews.left" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
            <div class="col-c">
              <ul class="list-news">
                <li v-for="(item, index) in brandNews.center" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
            <div class="col-r">
              <ul class="list-news">
                <li v-for="(item, index) in brandNews.right" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 设计前沿标签页 -->
        <div class="tab-con2" :class="{ ok: activeTab === 'design' }">
          <div class="row-news fix">
            <div class="col-l">
              <ul class="list-news">
                <li v-for="(item, index) in designNews.left" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
            <div class="col-c">
              <ul class="list-news">
                <li v-for="(item, index) in designNews.center" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
            <div class="col-r">
              <ul class="list-news">
                <li v-for="(item, index) in designNews.right" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 豪禾动态标签页 -->
        <div class="tab-con2" :class="{ ok: activeTab === 'news' }">
          <div class="row-news fix">
            <div class="col-l">
              <ul class="list-news">
                <li v-for="(item, index) in haoheNews.left" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
            <div class="col-c">
              <ul class="list-news">
                <li v-for="(item, index) in haoheNews.center" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
            <div class="col-r">
              <ul class="list-news">
                <li v-for="(item, index) in haoheNews.right" :key="index">
                  <a :href="item.link">{{ item.title }}</a>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {
      activeTab: 'brand',
      brandNews: {
        left: [
          { date: '2025/08/21', title: '视觉锤：让品牌在心智战场一击即中...', link: '2025/pinpaibaike_0821/25979.html' },
          { date: '2025/08/18', title: '品类创新的 6 大核心路径：从趋势到对立的落地指南...', link: '2025/positioning_0818/25978.html' },
          { date: '2025/08/04', title: '九大差异化定位：让品牌在消费者心智中占据不可替代的位置...', link: '2025/marketing_0804/25977.html' },
          { date: '2025/07/17', title: '豪禾广告在大健康行业有众多客户，涉及医疗器械、生物科技、健康服务、中医药等领域，...', link: 'guanggaowenda/2025/0717/25976.html' },
          { date: '2025/06/29', title: '上海食品包装设计公司豪禾（豪禾品牌设计）是一家具备15年以上行业经验的专业机构...', link: '2025/pinpaibaike_0629/25975.html' },
          { date: '2025/06/28', title: '老食品企业品牌策划-食品企业品牌升级建设规划...', link: '2025/brand_0628/25974.html' },
          { date: '2025/06/26', title: '国企品牌命名服务核心内容及豪禾服务案例解析...', link: '2025/brandname_0626/25973.html' },
          { date: '2025/06/24', title: '尊慈养老：一套VI设计系统如何重塑养老服务品牌温度与专业形象...', link: '2025/vi_0624/25972.html' },
          { date: '2025/06/23', title: '食品企业营销策划与突破经营困局建议...', link: '2025/brand_0623/25971.html' }
        ],
        center: [
          { date: '2025/12/07', title: '中船电站画册策划创意-国企宣传册设计...', link: 'about/list-catalog-1156-1.html' },
          { date: '2025/05/31', title: '上海医药品包装设计-AILEX 新冠抗原检测试剂盒包装设计案例说明...', link: 'about/list-pakcgeing-1155-1.html' },
          { date: '2025/05/30', title: '波乐乐儿童果味饮料包装设计：解锁童趣密码...', link: 'about/list-pakcgeing-1154-1.html' },
          { date: '2025/05/27', title: '药企厂区导视系统设计案例说明——青峰药业集团环境导视系统...', link: 'about/list-sign-1153-1.html' },
          { date: '2025/05/23', title: '大米包装设计-高墟碱米包装设计案例说明...', link: 'about/list-pakcgeing-1152-1.html' },
          { date: '2025/05/09', title: '傅雷图书馆导视系统案例- VIS设计...', link: 'about/list-sign-1150-1.html' },
          { date: '2025/02/24', title: '嘻嘻未来绘logo设计"品牌VI设计及SI空间设计...', link: '2025/logo_0224/1149.html' },
          { date: '2024/10/31', title: '鹏都农牧logo升级设计-农牧品牌升级设计...', link: '2024/logo_1031/1148.html' },
          { date: '2024/10/26', title: '高端矿泉水包装设计-氢纯水品牌设计...', link: 'about/list-pakcgeing-1147-1.html' }
        ],
        right: [
          { date: '2023/09/01', title: '面包烘焙行业应该如何突出产品特性？...', link: 'special/2023/0901/7744.html' },
          { date: '2023/08/24', title: '美妆品牌logo设计如何脱颖而出？...', link: 'special/2023/0824/7743.html' },
          { date: '2023/08/24', title: '国企集团公司如何进行品牌形象设计？...', link: 'special/2023/0824/7742.html' },
          { date: '2023/08/18', title: '鲜奶饮品品牌形象设计包括那些方面？...', link: 'special/2023/0818/7741.html' },
          { date: '2023/08/02', title: '上海logo设计公司可以从哪些要素上面寻找灵感？...', link: 'special/2023/0802/7740.html' },
          { date: '2023/08/02', title: '家居建材行业宣传册如何进行创意设计？...', link: 'special/2023/0802/7739.html' },
          { date: '2023/07/26', title: '精酿啤酒发展市场如何？品牌应该怎么设计？...', link: 'special/2023/0726/7738.html' },
          { date: '2023/07/26', title: '精酿啤酒品牌logo设计应该怎么设计？...', link: 'special/2023/0726/7737.html' },
          { date: '2023/07/20', title: '预制菜行业发展前景以及品牌设计方向...', link: 'special/2023/0720/7736.html' }
        ]
      },
      designNews: {
        left: [
          { date: '2023/05/05', title: '大和味袋装薯条包装策划食品包装设计是如何进行的...', link: '2023/about1_0505/25537.html' },
          { date: '2020/10/14', title: 'vi平面形象设计 -vi 形象设计是什么意思?...', link: '2020/about1_1014/23694.html' },
          { date: '2019/04/28', title: '一定要知道的广告平面设计中的一些潜在定律...', link: '2019/about1_0428/22396.html' },
          { date: '2018/12/07', title: '国外创意广告设计分享 | 10 个人中有 7 个在家过圣诞节...', link: '2018/about1_1207/21642.html' },
          { date: '2018/12/07', title: '大雪节气借势，这几个品牌设计灵感值得你来看！...', link: '2018/about1_1207/21641.html' },
          { date: '2016/08/22', title: '平面设计师不能不知道的企业CIS形象设计的要点(转载)...', link: '2016/about1_0822/4036.html' },
          { date: '2016/08/21', title: '目前平面设计师的前景还是不错的(转载)...', link: '2016/about1_0821/4029.html' },
          { date: '2016/08/03', title: '上海广告设计公司的技术业务内容...', link: '2016/about1_0803/3968.html' },
          { date: '2016/06/28', title: '平面广告设计必须遵循的七个原则...', link: '2016/about1_0628/3893.html' }
        ],
        center: [
          { date: '2016/05/27', title: '让品牌插上信仰的翅膀-净之初品牌构建案例...', link: '2016/about1_0527/3872.html' },
          { date: '2016/05/25', title: '上海VI设计阐述在VI设计中素材的运用...', link: '2016/about1_0525/3871.html' },
          { date: '2016/05/25', title: '公司标志设计是怎么回事-上海公司logo设计...', link: '2016/about1_0525/3869.html' },
          { date: '2016/05/25', title: '上海营销策划公司是做什么的...', link: '2016/about1_0525/3868.html' },
          { date: '2016/05/25', title: '如何提高企业品牌策划能力-上海企业品牌策划公司...', link: '2016/about1_0525/3867.html' },
          { date: '2016/05/25', title: 'VI设计公司的创作流程-上海VI设计公司...', link: '2016/about1_0525/3866.html' },
          { date: '2016/05/23', title: '企业VI设计——注意用特点来说话...', link: '2016/about1_0523/3863.html' },
          { date: '2016/05/20', title: '企业VI设计是企业的灵魂-上海企业VI设计...', link: '2016/about1_0520/3858.html' },
          { date: '2016/05/20', title: '品牌策划公司怎样体现消费者要素...', link: '2016/about1_0520/3857.html' }
        ],
        right: [
          { date: '2023/09/01', title: '面包烘焙行业应该如何突出产品特性？...', link: 'special/2023/0901/7744.html' },
          { date: '2023/08/24', title: '美妆品牌logo设计如何脱颖而出？...', link: 'special/2023/0824/7743.html' },
          { date: '2023/08/24', title: '国企集团公司如何进行品牌形象设计？...', link: 'special/2023/0824/7742.html' },
          { date: '2023/08/18', title: '鲜奶饮品品牌形象设计包括那些方面？...', link: 'special/2023/0818/7741.html' },
          { date: '2023/08/02', title: '上海logo设计公司可以从哪些要素上面寻找灵感？...', link: 'special/2023/0802/7740.html' },
          { date: '2023/08/02', title: '家居建材行业宣传册如何进行创意设计？...', link: 'special/2023/0802/7739.html' },
          { date: '2023/07/26', title: '精酿啤酒发展市场如何？品牌应该怎么设计？...', link: 'special/2023/0726/7738.html' },
          { date: '2023/07/26', title: '精酿啤酒品牌logo设计应该怎么设计？...', link: 'special/2023/0726/7737.html' },
          { date: '2023/07/20', title: '预制菜行业发展前景以及品牌设计方向...', link: 'special/2023/0720/7736.html' }
        ]
      },
      haoheNews: {
        left: [
          { date: '2025/02/01', title: '豪禾品牌 VI 设计公司的设计流程一般包括以下几个主要阶段...', link: '2025/about2_0201/25944.html' },
          { date: '2024/12/24', title: '豪禾公司的一些品牌策划成功案例：...', link: '2024/about2_1224/25929.html' },
          { date: '2024/12/01', title: '《豪禾品牌营销咨询：为企业点亮发展明灯，践行社会价值营销》...', link: '2024/about2_1201/25908.html' },
          { date: '2024/11/11', title: '豪禾品牌咨询为正昌集团品牌营销做了什么服务...', link: '2024/about2_1111/25881.html' },
          { date: '2024/11/11', title: '豪禾品牌营销咨询公司的发展历史是怎样的？...', link: '2024/about2_1111/25878.html' },
          { date: '2024/06/09', title: '邦迪特的VI设计以辅助图形-得到客户好评...', link: '2024/about2_0609/25822.html' },
          { date: '2023/10/10', title: '全力打造健康零食品牌：豪禾品牌咨询携手东阿阿胶达成战略合作...', link: '2023/about2_1010/25700.html' },
          { date: '2023/10/02', title: '豪禾与东阿阿胶合作品牌策划项目品牌命名、品牌广告语和品牌故事...', link: '2023/about2_1002/25680.html' },
          { date: '2023/04/26', title: '恭喜上海豪禾品牌咨询联合热泰能源达成B2B企业营销策划合作...', link: '2023/about2_0426/25531.html' }
        ],
        center: [
          { date: '2022/01/28', title: '上海豪禾山东分公司-潍坊品牌设计公司-品牌策划营销...', link: '2022/about2_0128/24311.html' },
          { date: '2022/01/01', title: '范定希:品牌战略—B2B企业赢得市场竞争的关键-B2B品牌营销培训大纲...', link: '2022/b2bnew_0101/24263.html' },
          { date: '2021/07/13', title: '学习华与华方法：透析华与华方法与案例史，助力中小企业发展...', link: '2021/about2_0713/24048.html' },
          { date: '2021/05/07', title: '热烈祝贺我公司乔迁之喜-开创新纪元，筑梦新征程...', link: '2021/about2_0507/23988.html' },
          { date: '2020/08/18', title: '上海璞境健康服务式公寓正式开业，豪禾带您饱览盛景...', link: '2020/about2_0818/23567.html' },
          { date: '2020/07/24', title: '上海璞境综合健康管理服务式公寓开业在即，快来体验全新YOUNG生主义吧！...', link: '2020/about2_0724/23517.html' },
          { date: '2020/07/15', title: '豪禾品牌恭贺熊觅·梅陇社区食堂热烈开业啦！...', link: '2020/about2_0715/23503.html' },
          { date: '2019/07/04', title: '豪禾品牌|asunfor御湘湖国际健康城品牌VI标志升级...', link: '2019/about2_0704/22663.html' },
          { date: '2019/07/04', title: '豪禾品牌咨询：有名品牌定位咨询公司具有哪些优势？...', link: '2019/about2_0704/22664.html' }
        ],
        right: [
          { date: '2023/09/01', title: '面包烘焙行业应该如何突出产品特性？...', link: 'special/2023/0901/7744.html' },
          { date: '2023/08/24', title: '美妆品牌logo设计如何脱颖而出？...', link: 'special/2023/0824/7743.html' },
          { date: '2023/08/24', title: '国企集团公司如何进行品牌形象设计？...', link: 'special/2023/0824/7742.html' },
          { date: '2023/08/18', title: '鲜奶饮品品牌形象设计包括那些方面？...', link: 'special/2023/0818/7741.html' },
          { date: '2023/08/02', title: '上海logo设计公司可以从哪些要素上面寻找灵感？...', link: 'special/2023/0802/7740.html' },
          { date: '2023/08/02', title: '家居建材行业宣传册如何进行创意设计？...', link: 'special/2023/0802/7739.html' },
          { date: '2023/07/26', title: '精酿啤酒发展市场如何？品牌应该怎么设计？...', link: 'special/2023/0726/7738.html' },
          { date: '2023/07/26', title: '精酿啤酒品牌logo设计应该怎么设计？...', link: 'special/2023/0726/7737.html' },
          { date: '2023/07/20', title: '预制菜行业发展前景以及品牌设计方向...', link: 'special/2023/0720/7736.html' }
        ]
      }
    }
  }
}
</script>

<style scoped>
.m-pro-g1 {
  padding: 80px 0;
  background: #f5f5f5;
  position: relative;
  overflow-x: visible;
  overflow-y: hidden;
}

.m-pro-g1 .wp {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
}

.g-tit-g1 {
  text-align: center;
  margin-bottom: 52px;
}

.g-tit-g1 h3 {
  font-size: 36px;
  color: #242526;
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: 6px;
}

.g-tit-g1 p {
  font-size: 24px;
  color: #666;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.ul-txt-g2 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  padding-bottom: 8px;
}

.ul-txt-g2::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 2px;
  background: #e0e0e0;
  z-index: 1;
}

.ul-txt-g2 li {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  padding: 0 10px;
}

.ul-txt-g2 li span {
  font-size: 20px;
  color: #242526;
  text-align: center;
  white-space: nowrap;
  margin-bottom: 15px;
  line-height: 1.4;
}

.ul-txt-g2 li::after {
  content: '';
  width: 16px;
  height: 16px;
  background: #EA4043;
  position: absolute;
  left: 50%;
  bottom: -15px;
  transform: translateX(-50%);
  z-index: 3;
  border-radius: 0;
  box-sizing: border-box;
}

.pic-consult.c2 {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  padding: 80px 0;
  text-align: center;
}

.pic-consult .wp {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.pic-consult .txt h3 {
  font-size: 36px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 400;
}

.pic-consult .txt .p1 {
  font-size: 18px;
  color: #ccc;
  margin-bottom: 40px;
}

.pic-consult .txt .btn {
  display: inline-block;
  padding: 15px 50px;
  background: #EA4043;
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  border-radius: 5px;
  transition: all 0.3s;
}

.pic-consult .txt .btn:hover {
  background: #d12e32;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(234, 64, 67, 0.4);
}

.m-center-g1 {
  padding: 80px 0;
  background: #fff;
}

.m-center-g1 .wp {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.ul-tab-g2 {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
}

.ul-tab-g2 li {
  margin: 0 10px;
  position: relative;
}

.ul-tab-g2 li a {
  display: block;
  padding: 8px 20px;
  font-size: 16px;
  color: #666;
  text-decoration: none;
  background: transparent;
  border-radius: 4px;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

.ul-tab-g2 li.on a {
  color: #fff;
  background: #EA4043;
}

.ul-tab-g2 li a:hover {
  color: #EA4043;
}

.tab-con2 {
  display: none;
}

.tab-con2.ok {
  display: block;
}

.row-news {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.row-news.fix::after {
  content: '';
  display: table;
  clear: both;
}

.col-l,
.col-c,
.col-r {
  flex: 1;
  width: 33.333%;
}

.list-news {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-news li {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  line-height: 1.6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

.list-news li:last-child {
  border-bottom: none;
}

.list-news a {
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  line-height: 1.6;
  flex: 1;
  margin-right: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-news .date {
  color: #999;
  font-size: 13px;
  display: inline-block;
  white-space: nowrap;
  flex-shrink: 0;
}

.list-news a:hover {
  color: #EA4043;
}

@media (max-width: 768px) {
  .m-pro-g1,
  .pic-consult.c2,
  .m-center-g1 {
    padding: 50px 0;
  }

  .g-tit-g1 h3 {
    font-size: 28px;
  }

  .g-tit-g1 p {
    font-size: 18px;
  }

  .ul-txt-g2 {
    flex-wrap: wrap;
    padding-bottom: 8px;
  }

  .ul-txt-g2::before {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
  }

  .ul-txt-g2 li {
    flex: 0 0 50%;
    margin-bottom: 40px;
    padding: 0 5px;
  }

  .ul-txt-g2 li::after {
    width: 14px;
    height: 14px;
    bottom: -6px;
  }

  .ul-txt-g2 li span {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .pic-consult .txt h3 {
    font-size: 28px;
  }

  .row-news {
    flex-direction: column;
    gap: 0;
  }

  .col-l,
  .col-c,
  .col-r {
    width: 100%;
    margin-bottom: 20px;
  }

  .ul-tab-g2 {
    flex-wrap: wrap;
    justify-content: center;
  }

  .ul-tab-g2 li {
    margin: 0 10px;
  }

  .ul-tab-g2 li a {
    font-size: 14px;
    padding: 10px 0;
  }
}
</style>